import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class DownloadService {
  constructor(private http: HttpClient) {}

  downloadFile(documentId: number): void {
    this.http
      .get(`api/download/${documentId}`, {
        responseType: "blob" as "json",
        observe: "response",
      })
      .subscribe((response: any) => this.download(response));
  }

  downloadDecisionFile(documentId: number): void {
    this.http
      .get(`api/download/decision/${documentId}`, {
        responseType: "blob" as "json",
        observe: "response",
      })
      .subscribe((response: any) => this.download(response));
  }

  download(response: any) {
    const dataType = response.body.type;
    const binaryData = [];
    binaryData.push(response.body);
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(
      new Blob(binaryData, { type: dataType }),
    );
    document.body.appendChild(downloadLink);
    const filename: string = this.getFileName(response);
    downloadLink.setAttribute("download", filename);
    downloadLink.click();
  }

  getFileName(response: HttpResponse<Blob>) {
    let filename: string;
    try {
      const contentDisposition: string = response.headers.get(
        "content-disposition",
      );
      const r = /(?:filename=)(.+)/;
      filename = r.exec(contentDisposition)[1];
      filename = filename.replace(/"/g, "");
    } catch (e) {
      console.log(e);
      filename = "document.pdf";
    }
    return filename;
  }
}
